import script from "./listUndanitas.vue?vue&type=script&setup=true&lang=js"
export * from "./listUndanitas.vue?vue&type=script&setup=true&lang=js"

import "./listUndanitas.vue?vue&type=style&index=0&id=41c542d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41c542d6"]])

export default __exports__